import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from 'components/responsive-fullscreen-dialog'
import {createPost} from 'helpers/command'
import Section from './Section'
import AssessmentError from './AssessmentError'

const useStyles = makeStyles(saveAssessmentStyles)
const useDialogStyles = makeStyles(dialogStyles)

export default function SaveAssessment ({isOpen, onClose, context, errors, assessmentErrors}) {

  const dialogClasses = useDialogStyles()
  const classes = useStyles() 
  const history = useHistory()
  const {translate, quizAssessment: assessment, assessment: assessmentId, quizSections: sections} = context

  async function handleSave() {
    const properties = update(assessment.properties, {validated: {$set: false}})
    await createPost('quiz', 'updateAssessmentProperties')({id: assessmentId, properties})
    history.push(context.link({}, context.quizEditFrom || '/:languageId/:role/:page/assessments', {query: context.quizEditFromQuery}))
  }

  return (
    <Dialog
      open={isOpen}
      close={onClose}
      dialogMaxWidth="lg"
      actionsClassName={classes.actions}
      dialogClasses={dialogClasses}
      confirm={
        <Button
          variant="contained"
          className={clsx(classes.button, "create")}
          color="primary"
          onClick={handleSave}>
            {translate('save')}
        </Button>
      }
      cancel={
        <Button
          variant="contained"
          className={clsx(classes.button, "cancel")}
          onClick={onClose}>
            {translate('cancel')}
        </Button>
      }
      title={translate('save-with-errors-dialog-title')}
    >
      <Box className={classes.root}>
        {assessmentErrors.length > 0 && (
        <Box className={classes.assessment}>
          <Box className={classes.label}>{translate('assessment-errors-label')}</Box>
          <Box className={classes.errors}>
            {assessmentErrors.map((error,index) => <AssessmentError key={index} {...{error, context}} />)}
          </Box>
        </Box>
        )}
        <Box className={classes.sections}>
          {errors.map(section => (<Section key={section.id} {...{section, context}} />))}
        </Box>
      </Box>
    </Dialog>
  )
}

function saveAssessmentStyles(theme) {

  return {
    actions: {
      marginTop: 20
    },
    label: {
      color: '#68728b',
      fontWeight: 'bold',
      fontSize: '13pt'
    },
    errors: {
      display: 'flex',
      flexDirection: 'column',
      padding: 10
    },
    button: {
      "&.create": {
        marginLeft: 20
      }
    },
    sections: {
    }
  }
}

function dialogStyles(theme) {

  return {
    paper: {
      padding: 20
    },
  }
}
